import { render, staticRenderFns } from "./ClickToCallModal.vue?vue&type=template&id=412f9a5a&scoped=true&"
import script from "./ClickToCallModal.vue?vue&type=script&lang=js&"
export * from "./ClickToCallModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412f9a5a",
  null
  
)

export default component.exports